/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_AccionAsync as AccionAsync,
  rec_Componente_MDolar_77_36 as Componente_MDolar_77_36,
  rec_Componente_NDolar_78_36 as Componente_NDolar_78_36,
  rec_Componente_jDolar_106_36 as Componente_jDolar_106_36,
  rec_EstadoError as EstadoError,
  rec_Fo as Fo,
  rec_FotoIncidencia as FotoIncidencia,
  rec_Go as Go,
  rec_JSXRuntime as JSXRuntime,
  rec_Modal as Modal,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_api as api,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function DetalleIncidencia(e) {
  let t = (0, ReactCompiler.c)(44),
    { id: n, onCerrar: r, onCambio: i } = e,
    a = Go(),
    { confirmar: o, pedirTexto: s } = Fo(),
    [c, l] = (0, React.useState)(null),
    [u, f] = (0, React.useState)(``),
    [p, m] = (0, React.useState)(!1),
    h;
  t[0] === n
    ? (h = t[1])
    : ((h = async () => {
        f(``);
        try {
          l(
            await api(`/incidencias/${n}`, {
              sinCache: !0,
            }),
          );
        } catch (e) {
          f(e.message);
        }
      }),
      (t[0] = n),
      (t[1] = h));
  let _ = h,
    v,
    y;
  (t[2] === _
    ? ((v = t[3]), (y = t[4]))
    : ((v = () => {
        _();
      }),
      (y = [_]),
      (t[2] = _),
      (t[3] = v),
      (t[4] = y)),
    (0, React.useEffect)(v, y));
  let b;
  t[5] !== a || t[6] !== p || t[7] !== i
    ? ((b = async function (e, t) {
        if (!p) {
          (m(!0), f(``));
          try {
            (await e(), a.ok(t), await i());
          } catch (e) {
            let t = e;
            (f(t.message), a.error(t.message), m(!1));
          }
        }
      }),
      (t[5] = a),
      (t[6] = p),
      (t[7] = i),
      (t[8] = b))
    : (b = t[8]);
  let x = b,
    S;
  t[9] !== x || t[10] !== n
    ? ((S = () =>
        x(
          () =>
            api(`/incidencias/${n}/tomar`, {
              method: `POST`,
            }),
          `Quedó a tu cargo`,
        )),
      (t[9] = x),
      (t[10] = n),
      (t[11] = S))
    : (S = t[11]);
  let C = S,
    w;
  t[12] !== x || t[13] !== n || t[14] !== s
    ? ((w = async function () {
        let e = await s({
          titulo: `Resolver`,
          mensaje: `¿Qué se hizo para resolverla?`,
          confirmarTexto: `Resolver`,
        });
        e?.trim() &&
          (await x(
            () =>
              api(`/incidencias/${n}/resolver`, {
                method: `POST`,
                body: JSON.stringify({
                  solucion: e,
                }),
              }),
            `Resuelta`,
          ));
      }),
      (t[12] = x),
      (t[13] = n),
      (t[14] = s),
      (t[15] = w))
    : (w = t[15]);
  let T = w,
    E;
  t[16] !== x || t[17] !== o || t[18] !== n || t[19] !== s
    ? ((E = async function () {
        let e = await s({
          titulo: `Anular`,
          mensaje: `¿Por qué se anula? Queda escrito.`,
          confirmarTexto: `Anular`,
        });
        e?.trim() &&
          (await o({
            titulo: `Anular la incidencia`,
            mensaje: `No se borra: queda registrada con su motivo.`,
            confirmarTexto: `Anular`,
            peligro: !0,
          })) &&
          (await x(
            () =>
              api(`/incidencias/${n}/anular`, {
                method: `POST`,
                body: JSON.stringify({
                  motivo: e,
                }),
              }),
            `Anulada`,
          ));
      }),
      (t[16] = x),
      (t[17] = o),
      (t[18] = n),
      (t[19] = s),
      (t[20] = E))
    : (E = t[20]);
  let D = E,
    O = c && (c.estado === `REPORTADA` || c.estado === `EN_PROCESO`),
    k;
  t[21] === c?.respuestas
    ? (k = t[22])
    : ((k = c?.respuestas ?? []), (t[21] = c?.respuestas), (t[22] = k));
  let A = k,
    j;
  t[23] === c?.fotos
    ? (j = t[24])
    : ((j = c?.fotos ?? []), (t[23] = c?.fotos), (t[24] = j));
  let M = j,
    N;
  t[25] === c?.eventos
    ? (N = t[26])
    : ((N = c?.eventos ?? []), (t[25] = c?.eventos), (t[26] = N));
  let P = N,
    F = c ? `${c.tipo} · ${c.codigo ?? ``}` : `Incidencia`,
    I;
  t[27] !== O ||
  t[28] !== D ||
  t[29] !== _ ||
  t[30] !== u ||
  t[31] !== P ||
  t[32] !== c ||
  t[33] !== M ||
  t[34] !== n ||
  t[35] !== p ||
  t[36] !== T ||
  t[37] !== A ||
  t[38] !== C
    ? ((I = c ? (
        <div
          className={`flex flex-col gap-4`}
          children={[
            <EstadoError mensaje={u} />,
            <div
              className={`grid grid-cols-2 gap-2 text-sm`}
              children={[
                <Componente_NDolar_78_36
                  titulo={`Dónde`}
                  valor={c.ubicacion || c.fundo}
                />,
                <Componente_NDolar_78_36
                  titulo={`Área`}
                  valor={c.area || `Sin área todavía`}
                />,
                c.criticidad && (
                  <Componente_NDolar_78_36
                    titulo={`Gravedad`}
                    valor={c.criticidad}
                  />
                ),
                <Componente_NDolar_78_36
                  titulo={`Quien reportó`}
                  valor={c.reportadoPor}
                />,
                c.asignadoA && (
                  <Componente_NDolar_78_36
                    titulo={`A cargo`}
                    valor={c.asignadoA}
                  />
                ),
                c.minutosEnTomar != null && (
                  <Componente_NDolar_78_36
                    titulo={`Tardaron en mirarla`}
                    valor={`${c.minutosEnTomar} min`}
                  />
                ),
                c.minutosEnResolver != null && (
                  <Componente_NDolar_78_36
                    titulo={`Tardaron en resolverla`}
                    valor={`${c.minutosEnResolver} min`}
                  />
                ),
              ]}
            />,
            c.observaciones && (
              <p
                className={`break-words text-sm text-(--text)`}
                children={c.observaciones}
              />
            ),
            A.length > 0 && (
              <ul
                className={`flex flex-col gap-1 text-sm`}
                children={A.map(Componente_MDolar_77_36)}
              />
            ),
            <div
              className={`grid grid-cols-2 gap-2`}
              children={M.map((e) => (
                <FotoIncidencia key={e.id} incidenciaId={n} foto={e} />
              ))}
            />,
            c.solucion && (
              <div
                className={`rounded-xl bg-(--success-bg) p-3 text-sm`}
                children={[
                  <p
                    className={`font-medium text-(--text-h)`}
                    children={`Cómo se resolvió`}
                  />,
                  <p className={`break-words`} children={c.solucion} />,
                ]}
              />
            ),
            c.motivoCierre && (
              <div
                className={`rounded-xl bg-(--warning-bg) p-3 text-sm`}
                children={
                  <p className={`break-words`} children={c.motivoCierre} />
                }
              />
            ),
            <section
              className={`flex flex-col gap-2`}
              children={[
                <p
                  className={`text-xs font-medium uppercase tracking-wide text-(--text)`}
                  children={`Qué pasó`}
                />,
                <ol
                  className={`flex flex-col gap-2 border-l border-(--border) pl-3 text-sm`}
                  children={P.map(Componente_jDolar_106_36)}
                />,
              ]}
            />,
            O && c.puedeAtender && (
              <div
                className={`flex flex-wrap justify-end gap-2 border-t border-(--border) pt-3`}
                children={[
                  c.estado === `REPORTADA` && (
                    <AccionAsync
                      variante={`secundario`}
                      className={`min-h-11`}
                      disabled={p}
                      onClick={C}
                      children={`La tomo yo`}
                    />
                  ),
                  c.puedeDerivar && (
                    <AccionAsync
                      variante={`texto`}
                      className={`min-h-11`}
                      disabled={p}
                      onClick={D}
                      children={`Anular`}
                    />
                  ),
                  <AccionAsync
                    className={`min-h-11`}
                    disabled={p}
                    onClick={T}
                    children={[
                      p &&
                        (0, JSXRuntime.jsx)(ii, {
                          className: `mr-1 inline h-4 w-4 animate-spin`,
                        }),
                      `Resolver`,
                    ]}
                  />,
                ]}
              />
            ),
          ]}
        />
      ) : u ? (
        <EstadoError mensaje={u} onReintentar={_} />
      ) : (
        <div
          className={`flex justify-center py-10 text-(--text)`}
          children={(0, JSXRuntime.jsx)(ii, {
            className: `h-5 w-5 animate-spin`,
          })}
        />
      )),
      (t[27] = O),
      (t[28] = D),
      (t[29] = _),
      (t[30] = u),
      (t[31] = P),
      (t[32] = c),
      (t[33] = M),
      (t[34] = n),
      (t[35] = p),
      (t[36] = T),
      (t[37] = A),
      (t[38] = C),
      (t[39] = I))
    : (I = t[39]);
  let L;
  return (
    t[40] !== r || t[41] !== F || t[42] !== I
      ? ((L = <Modal titulo={F} onClose={r} children={I} />),
        (t[40] = r),
        (t[41] = F),
        (t[42] = I),
        (t[43] = L))
      : (L = t[43]),
    L
  );
}
